<template>
    <div class="contacts-sales-department">
      <div class="constacts-sales-department-filters" ref="contactsSalesDepartmentFilters">
        <div class="filter-main" @click="toggleDropdown(0)">
          <span v-if="!selectedRegion">Region</span>
          <span v-if="selectedRegion" class="strong">{{selectedRegion}}</span>
          <span class="alcomet filter-arrow">I</span>
          <div class="filter-dropdown" v-if="isDropdownOpened[0]">
            <ul>
              <li @click="resetRegion()">Show all</li>
              <li v-for="(region, index) in regionsArray" :key="index" @click="selectRegion(region)">
                {{region}}
              </li>
            </ul>
          </div>
        </div>
        <div class="filter-main" @click="toggleDropdown(1)">
          <span v-if="!selectedProduct">Products</span>
          <span v-if="selectedProduct" class="strong">{{selectedProduct}}</span>
          <span class="alcomet filter-arrow">I</span>
          <div class="filter-dropdown" v-if="isDropdownOpened[1]">
            <ul>
              <li @click="selectedProduct = ''">Show all</li>
              <li v-for="(product, index) in productsArray" :key="index" @click="selectProduct(product)">
                {{product}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="contacts-sales-staff">
        <div v-for="(staff, index) in mainStaffArray" :key="index" class="staff-profile" @click="selectProfile(staff)">
          <div class="staff-avatar-back2"></div>
          <div v-if="staff.img" class="staff-avatar" :style="{backgroundImage: 'url(' + staff.img + ')'}"></div>
          <span v-if="!staff.img" class="staff-avatarless">
              <span class="alcomet">a</span>
          </span>
          <h3>{{staff.name}}</h3>
          <h4>{{staff.position}}</h4>
        </div>
      </div>
      <div v-if="!selectedRegion && !selectedProduct" class="contacts-sales-staff">
        <div v-for="(staff, index) in staffArray" :key="index" class="staff-profile" @click="selectProfile(staff)">
          <div class="staff-avatar-back2"></div>
          <div v-if="staff.img" class="staff-avatar" :style="{backgroundImage: 'url(' + staff.img + ')'}"></div>
          <span v-if="!staff.img" class="staff-avatarless">
              <span class="alcomet">a</span>
          </span>
          <h3>{{staff.name}}</h3>
          <h4>{{staff.position}}</h4>
        </div>
      </div>
      <div v-if="selectedRegion || selectedProduct" class="contacts-sales-staff">
        <div v-for="(staff, index) in resultArray" :key="index" class="staff-profile" @click="selectProfile(staff)">
          <div class="staff-avatar-back2"></div>
          <div v-if="staff.img" class="staff-avatar" :style="{backgroundImage: 'url(' + staff.img + ')'}"></div>
          <span v-if="!staff.img" class="staff-avatarless">
              <span class="alcomet">a</span>
          </span>
          <h3>{{staff.name}}</h3>
          <h4>{{staff.position}}</h4>
        </div>
       </div>
      <app-profile-modal v-if="selectedProfile" :staffProfile="selectedProfile"></app-profile-modal>
    </div>
</template>

<script>
import Staff from "./SalesDepartment.json";
import mainStaff from "./MainSalesDepartment.json";
import ProfileModal from "./ProfileModal";
export default {
  components: {
    appProfileModal: ProfileModal
  },
  data() {
    return {
      isDropdownOpened: [false, false],
      staffArray: Staff,
      mainStaffArray: mainStaff,
      resultArray: [],
      regionsArray: [],
      selectedRegion: "",
      productsArray: [],
      selectedProduct: "",
      selectedProfile: undefined
    };
  },
  methods: {
    toggleDropdown(i) {
      this.$set(
        this.isDropdownOpened,
        i,
        this.isDropdownOpened[i] == false ? true : false
      );
    },
    selectRegion(region) {
      this.selectedRegion = region;
      this.$eventHub.$emit("region-dropdown-selected", region);
      this.filterResults();
    },
    selectProduct(product) {
      this.selectedProduct = product;
      this.filterResults();
    },
    // TODO : REFACTOR THIS
    filterResults() {
      if (this.selectedRegion && !this.selectedProduct) {
        this.resultArray = this.staffArray.filter(r => {
          if (r.countries) {
            for (let i = 0; i < r.countries.length; i++) {
              if (r.countries[i] == this.selectedRegion) {
                return true;
              }
            }
            return false;
          } else {
            return true;
          }
        });
      } else if (!this.selectedRegion && this.selectedProduct) {
        this.resultArray = this.staffArray.filter(r => {
          if (r.products) {
            for (let i = 0; i < r.products.length; i++) {
              if (r.products[i] == this.selectedProduct) {
                return true;
              }
            }
            return false;
          } else {
            return true;
          }
        });
      } else {
        this.resultArray = this.staffArray.filter(r => {
          if (r.countries) {
            for (let i = 0; i < r.countries.length; i++) {
              if (r.countries[i] == this.selectedRegion) {
                return true;
              }
            }
            return false;
          } else {
            return true;
          }
        });
        this.resultArray = this.resultArray.filter(r => {
          if (r.products) {
            for (let i = 0; i < r.products.length; i++) {
              if (r.products[i] == this.selectedProduct) {
                return true;
              }
            }
            return false;
          } else {
            return true;
          }
        });
      }
    },
    selectProfile(profile) {
      this.selectedProfile = profile;
      // add the custom profile url to the main url
      this.$router.replace({
        name: "ContactsProfile",
        params: { page: "sales-department", profile: profile.url }
      });
    },
    resetRegion() {
      this.selectedRegion = "";
      this.$eventHub.$emit("region-dropdown-selected", "");
    }
  },
  mounted() {
    // find profile if params profile
    if (this.$route.params.profile) {
      this.selectedProfile = this.staffArray.filter(s => {
        return s.url === this.$route.params.profile;
      })[0];
    }
    // listen for the 'close-profile' event from ProfileModal.vue
    this.$eventHub.$on("close-profile", () => {
      this.selectedProfile = undefined;
      this.$router.replace({
        name: "Contacts",
        params: { page: "sales-department" }
      });
    });
    // listen for the 'region-selected" event from ./Header.vue
    this.$eventHub.$on("region-selected", region => {
      this.selectRegion(region);
      this.$refs.contactsSalesDepartmentFilters.scrollIntoView({
        behavior: "smooth"
      });
    });
    // init filters based on staff
    for (let i = 0; i < this.staffArray.length; i++) {
      if (this.staffArray[i].countries) {
        for (let j = 0; j < this.staffArray[i].countries.length; j++) {
          if (
            this.regionsArray.indexOf(this.staffArray[i].countries[j]) == -1
          ) {
            this.regionsArray.push(this.staffArray[i].countries[j]);
          }
        }
        this.regionsArray.sort();
      }
      if (this.staffArray[i].products) {
        for (let j = 0; j < this.staffArray[i].products.length; j++) {
          if (
            this.productsArray.indexOf(this.staffArray[i].products[j]) == -1
          ) {
            this.productsArray.push(this.staffArray[i].products[j]);
          }
        }
      }
    }
  },
  destroyed() {
    this.$eventHub.$off("close-profile");
    this.$eventHub.$off("region-selected");
  }
};
</script>

<style scoped>
.contacts-sales-department {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 40px;
}
.constacts-sales-department-filters {
  display: flex;
  padding: 20px 0 50px;
}
.filter-main {
  align-items: center;
  background-color: #e0ecf4;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  font-size: 12px;
  height: 40px;
  justify-content: space-between;
  margin: 0 20px;
  padding: 0 20px;
  position: relative;
  width: 280px;
}
.filter-dropdown {
  background-color: #e0ecf4;
  border-radius: 6px;
  max-height: 200px;
  left: 0;
  overflow: auto;
  position: absolute;
  top: 50px;
  width: 100%;
  z-index: 1;
}
.filter-arrow {
  position: absolute;
  right: 20px;
  top: 14px;
}
.filter-dropdown ul li {
  display: block;
  padding: 10px 20px;
  font-size: 12px;
}
.filter-dropdown ul li:hover {
  background-color: #cfdee9;
}
.contacts-sales-staff {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 1000px;
}
.staff-profile {
  align-items: center;
  cursor: pointer;
  display: flex;
  padding-top: 220px;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 280px;
}
.staff-avatar,
.staff-avatar-back2,
.staff-avatarless {
  background-size: cover;
  background-position: center;
  border: 5px solid #dcebf4;
  border-radius: 50%;
  left: calc(50% - 110px);
  position: absolute;
  top: 0;
  height: 220px;
  width: 220px;
}
.staff-avatarless {
  align-items: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.staff-avatarless span {
  font-size: 100px;
}
.staff-avatar {
  -webkit-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  -moz-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  -ms-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: transform 3s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.staff-avatar-back2 {
  background-color: #dcebf4;
  border: 0;
  height: 220px;
  opacity: 0.3;
  -webkit-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -moz-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -ms-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: all 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  width: 220px;
}

.staff-avatar-back2::before {
  background: #dcebf4;
  border-radius: 50%;
  content: "";
  height: 220px;
  opacity: 0.8;
  position: absolute;
  width: 220px;
  z-index: 200;
}

.staff-profile:hover .staff-avatar {
  transform: scale(1.03);
}

.staff-profile:hover .staff-avatar-back2 {
  height: 240px;
  left: 20px;
  top: -10px;
  width: 240px;
}

.staff-profile:hover .staff-avatar-back2::before {
  width: 220px;
}

@keyframes rotate {
  0% {
  }
  100% {
    transform: rotate(360deg);
  }
}

.staff-profile h3 {
  font-size: 24px;
  text-align: center;
  margin: 10px 0;
}
.staff-profile h4 {
  font-size: 14px;
  height: 80px;
  text-transform: uppercase;
  text-align: center;
  width: 220px;
}
.strong {
  font-weight: 700;
}

@media screen and (max-width: 1700px) {
}
@media screen and (max-width: 1280px) {
  .contacts-sales-staff {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  .constacts-sales-department-filters {
    justify-content: center;
    padding-left: 30px;
    padding-right: 30px;
    width: 100%;
  }
  .contacts-sales-staff {
    width: 100%;
  }
  .staff-profile h3 {
    font-size: 20px;
    margin: 10px 0 5px;
  }
  .staff-profile h4 {
    font-size: 12px;
  }
}
@media screen and (max-width: 600px) {
  .contacts-sales-department {
    padding: 0;
  }
  .constacts-sales-department-filters {
    justify-content: space-between;
  }
  .filter-main {
    margin: 0;
    width: calc(50% - 10px);
  }
  .staff-profile {
    align-items: flex-start;
    margin: 10px 0;
    min-height: 80px;
    padding: 0 30px 0 130px;
    width: 100%;
  }
  .staff-avatar,
  .staff-avatarless {
    border: 2px solid #dcebf4;
    height: 80px;
    left: 30px;
    width: 80px;
  }
  .staff-avatar-back2 {
    display: none;
  }
  .staff-avatarless span {
    font-size: 30px;
  }
  .staff-profile h3 {
    margin-top: 0;
    text-align: left;
    width: 100%;
  }
  .staff-profile h4 {
    height: initial;
    text-align: left;
    width: 100%;
  }
}
@media screen and (max-width: 380px) {
  .staff-profile h3 {
    font-size: 16px;
  }
  .staff-profile h4 {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/SalesDepartment.vue